import { render, staticRenderFns } from "./deviceItem_sel.vue?vue&type=template&id=0ead5242&scoped=true"
import script from "./deviceItem_sel.vue?vue&type=script&lang=js"
export * from "./deviceItem_sel.vue?vue&type=script&lang=js"
import style0 from "./deviceItem_sel.vue?vue&type=style&index=0&id=0ead5242&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead5242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ead5242')) {
      api.createRecord('0ead5242', component.options)
    } else {
      api.reload('0ead5242', component.options)
    }
    module.hot.accept("./deviceItem_sel.vue?vue&type=template&id=0ead5242&scoped=true", function () {
      api.rerender('0ead5242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/deviceItem_sel.vue"
export default component.exports